// import { EventCard } from '~/domains/events/components/event-card/event-card'
import { useSchedulerCalendar } from './provider'
import type { SchedulerCalendarEvent } from './types'

export const EventPreviewDefault = <T,>({
	event,
}: {
	event: SchedulerCalendarEvent<T>
}) => {
	const { renderSelectedEvent } = useSchedulerCalendar()

	return (
		<div data-scheduler-active-event-card='true'>
			{renderSelectedEvent?.({ event })}
			{/* <EventCard
				event={event.metadata as never}
				className='shadow-[inset_0_0_0_2px_#ff4338]!'
			/> */}
		</div>
	)
}
